@if (order()) {
  <lfw-form-edit-toolbar>
    <ng-container toolbar-left>
      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.SAVE' | translate }}"
        icon="save"
        (click)="save()"
        [disabled]="!canSave()">
      </lfw-toolbar-button>
      <lfw-toolbar-divider class="desktop-only" />
      <lfw-toolbar-button
        class="desktop-only"
        [disabled]="true"
        label="{{ 'ORDERS.FINISH' | translate }}"
        icon="check_circle"
        [tooltip]="'ORDERS.ACTION_TOOLTIP_NOT_POSSIBLE_WHILE_OFFLINE' | translate"
        (click)="finalize()">
      </lfw-toolbar-button>
    </ng-container>

    <ng-container toolbar-center>
      <lfw-toolbar-text text="{{ caption }}" />
    </ng-container>

    <ng-container toolbar-right>
      <lfw-order-editor-mobile-menu
        [canSave]="canSave()"
        [canFinalize]="false"
        [tooltipForFinalizeButton]="'ORDERS.ACTION_TOOLTIP_NOT_POSSIBLE_WHILE_OFFLINE' | translate"
        (save)="save()"
        (finalize)="finalize()"
        (closeForm)="close()" />

      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.CLOSE' | translate }}"
        icon="close"
        (click)="close()" />
    </ng-container>

    <ng-container toolbar-substate>
      @if (order()!.form) {
        <lfw-sub-state-select
          [disabled]="isConflicted()"
          [availableStates]="order()!.form.subStates"
          (changed)="subStateSelectionChanged()"
          [(order)]="order()!.form.order" />
      }
    </ng-container>
  </lfw-form-edit-toolbar>

  @if (isConflicted()) {
    <div class="conflict-banner" role="note">
      <mat-icon aria-hidden="true">info</mat-icon>
      <span>{{ 'ORDERS.CONFLICT_TOOLTIP_OFFLINE' | translate }}</span>
      <mat-icon aria-hidden="true">info</mat-icon>
    </div>
  }

  <lfe-liveforms-editor
    #editor
    [form]="order()!.form"
    [userInfo]="user"
    [settings]="editorSettings"
    [disabled]="isConflicted()"
    (formChanged)="formChanged()" />
}
